var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e3f8fa;}.b{fill:#26c6da;}.c{fill:#8ce1eb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.75,60H11.25A11.249,11.249,0,0,1,0,48.75V11.25A11.249,11.249,0,0,1,11.25,0h37.5A11.249,11.249,0,0,1,60,11.25v37.5A11.249,11.249,0,0,1,48.75,60Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.928,15.979H18.99a.989.989,0,1,1,0-1.979h5.938a.989.989,0,1,1,0,1.979Z",
    transform: "translate(17.156 12.488)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29.449,18.646H9.656a.99.99,0,0,1,0-1.98H29.447a.99.99,0,0,1,0,1.98Z",
    transform: "translate(10.447 14.866)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.449,21.313H9.656a.99.99,0,0,1,0-1.98H29.447a.99.99,0,0,1,0,1.98Z",
    transform: "translate(10.447 17.245)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29.449,23.979H9.656a.989.989,0,1,1,0-1.979H29.447a.989.989,0,0,1,0,1.979Z",
    transform: "translate(10.447 19.624)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.058,8.667H10.151a1.487,1.487,0,0,0-1.484,1.484v6.928a1.487,1.487,0,0,0,1.484,1.484h8.906a1.487,1.487,0,0,0,1.484-1.484V10.151A1.486,1.486,0,0,0,19.058,8.667Zm-.5,1.979v3.993l-1.406-1.265a.991.991,0,0,0-1.377.052l-1.608,1.685-.779-.732A.988.988,0,0,0,12,14.417l-1.352,1.418V10.646Z",
    transform: "translate(8.712 8.475)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.a931eb3c54d0c479e9e2c2bee5a4ae81.svg";
export { ForwardRef as ReactComponent };